//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { SalaryFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
import { DateHelper, QueryStateHelper } from "utils/helpers";

function useGrossSalaryReportFilterDefinition() {
  const filterFormFields: GenericFormSection<SalaryFormTypes.GrossSalaryFilter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        year: {
          label: TranslationKeys.Common.YearPascal,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            items: [...Array(10).keys()].map((i) => ({
              value: (DateHelper.getYear(DateHelper.today()) - i).toString(),
            })),
          } as AutoCompleteExtraProps<SalaryFormTypes.GrossSalaryFilter>,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<SalaryFormTypes.GrossSalaryFilter> = {
    year: QueryStateHelper.numberQueryEncoder(FormFieldConstants.Salary.GrossSalaryFilter.Year),
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useGrossSalaryReportFilterDefinition;
